import React, { useMemo } from 'react';

import { TaskBoardColumnsType } from '../taskBoardTypes';
import { TaskBoardColumn } from './taskBoardColumn';

export interface TaskBoardColumnsProps {
    columns: TaskBoardColumnsType;
}

export const TaskBoardColumns: React.FC<TaskBoardColumnsProps> = ({ columns }) => {
    const TaskColumns = useMemo(() => {
        return Object.entries(columns).map(([columnId, column]) => {
            return <TaskBoardColumn key={columnId} column={column} />;
        });
    }, [columns]);

    return <div style={{ display: 'flex', gap: 8 }}>{TaskColumns}</div>;
};
